import React from "react";
import { Link } from "react-router-dom";
import HeroImage from "../../images/home/pic1.jpg";
import SelectedOne from "../../images/home/pic3.jpg";
import SelectedTwo from "../../images/home/pic4.jpg";
import SelectedThree from "../../images/home/pic1.jpg";

// Copy follows Anachronistic_Homepage_Redesign_and_Content_Brief.pdf.
// Images are placeholders until photographs of real inventory are supplied.

const departments = [
  {
    title: "Antiques and Decorative Arts",
    text: "Furniture, ceramics, silver and decorative objects selected for their craftsmanship, character and collecting interest.",
  },
  {
    title: "Antiquities and Historical Objects",
    text: "Objects from earlier cultures and periods, considered through their available provenance, condition and supporting documentation.",
  },
  {
    title: "Fine Art",
    text: "Paintings, sculpture and works on paper, bringing artistic expression into conversation with the objects of the past.",
  },
];

const selectedObjects = [SelectedOne, SelectedTwo, SelectedThree];

function HomeRedesign() {
  return (
    <div className="aah-home">
      {/* 2. Opening section */}
      <section className="aah-hero">
        <div className="aah-container aah-hero__grid">
          <div className="aah-hero__text">
            <p className="aah-eyebrow">Anachronistic Auction House</p>
            <p className="aah-location">Dubai, United Arab Emirates</p>
            <h1>Exceptional Antiques, Antiquities and Fine Art</h1>
            <p className="aah-lead">
              Discover historical objects and distinctive works of art. Explore opportunities to
              collect, sell or discuss a private acquisition with Anachronistic Auction House.
            </p>
            <div className="aah-actions">
              <Link to="/auction" className="aah-btn aah-btn--primary">Explore the Collection</Link>
              <Link to="/contactus" className="aah-btn aah-btn--outline">Submit an Object</Link>
            </div>
          </div>
          <div className="aah-hero__image">
            <img src={HeroImage} alt="Featured work from the collection" />
          </div>
        </div>
      </section>

      {/* 3. Departments */}
      <section className="aah-section">
        <div className="aah-container">
          <h2 className="aah-heading">Explore Our Departments</h2>
          <div className="aah-grid aah-grid--3">
            {departments.map((d) => (
              <article key={d.title} className="aah-card">
                <h3>{d.title}</h3>
                <p>{d.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 4. Selected objects */}
      <section className="aah-section aah-section--white">
        <div className="aah-container">
          <h2 className="aah-heading">Selected Objects</h2>
          <p className="aah-intro">
            Explore a selection of objects offered through the house. Enquire for availability,
            condition information and supporting documentation.
          </p>
          <div className="aah-grid aah-grid--3 aah-objects">
            {selectedObjects.map((src, i) => (
              <figure key={i}>
                <img src={src} alt={`Selected object ${i + 1}`} loading="lazy" />
              </figure>
            ))}
          </div>
          <div className="aah-center">
            <Link to="/auction" className="aah-btn aah-btn--primary">View Selected Objects</Link>
          </div>
        </div>
      </section>

      {/* 5. Private sales */}
      <section className="aah-section">
        <div className="aah-container aah-split">
          <div>
            <h2 className="aah-heading">Private Sales and Collector Enquiries</h2>
            <p className="aah-subhead">A discreet approach to buying and selling.</p>
          </div>
          <div>
            <p>
              Whether you are considering the sale of a single object, seeking a particular work or
              developing a collection, discuss your requirements with us confidentially. Private sale
              opportunities and viewings are arranged individually, subject to availability.
            </p>
            <Link to="/contactus" className="aah-btn aah-btn--primary">Enquire About Private Sales</Link>
          </div>
        </div>
      </section>

      {/* 6. Seller submission */}
      <section className="aah-section aah-section--white">
        <div className="aah-container aah-split">
          <div>
            <h2 className="aah-heading">Considering Selling an Object</h2>
          </div>
          <div>
            <p>
              Begin with photographs and the information you already hold. Share the object’s
              dimensions, materials, condition, acquisition history and any previous reports or
              documents. Following an initial review, we will discuss whether further examination or
              a sale proposal is appropriate.
            </p>
            <Link to="/contactus" className="aah-btn aah-btn--primary">Submit an Object for Review</Link>
          </div>
        </div>
      </section>

      {/* 7. Examination and documentation */}
      <section className="aah-section">
        <div className="aah-container aah-split">
          <div>
            <h2 className="aah-heading">Examination and Documentation</h2>
            <p className="aah-subhead">Understanding an object begins with careful examination.</p>
          </div>
          <div>
            <p>
              Our proposed assessment process considers physical characteristics, condition,
              available ownership history and relevant comparisons. Where an unresolved question
              warrants scientific investigation, appropriate external testing may be recommended.
            </p>
            <p>
              Scientific testing, including radiocarbon dating, is considered only where suitable
              for the material and the question being investigated.
            </p>
            <Link to="/faq" className="aah-btn aah-btn--outline">Learn About Our Assessment Process</Link>
          </div>
        </div>
      </section>

      {/* 8. Company introduction */}
      <section className="aah-section aah-section--white">
        <div className="aah-container aah-narrow">
          <h2 className="aah-heading">About Anachronistic Auction House</h2>
          <p>
            Based in Dubai, Anachronistic Auction House brings together antiques, historical objects
            and fine art through a considered approach to collecting and private sales. We welcome
            enquiries from owners and collectors who wish to explore the history, documentation and
            sale possibilities of an object.
          </p>
          <Link to="/aboutus" className="aah-btn aah-btn--outline">Discover the House</Link>
        </div>
      </section>

      {/* 9. Appointment invitation */}
      <section className="aah-cta">
        <div className="aah-container aah-narrow">
          <h2>Discuss Your Collection</h2>
          <p>Have an object to submit or a collecting interest to discuss?</p>
          <div className="aah-actions aah-actions--center">
            <Link to="/contactus" className="aah-btn aah-btn--light">Request an Appointment</Link>
            <Link to="/contactus" className="aah-btn aah-btn--ghost">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomeRedesign;
